import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useCentroCustoOutletContext } from 'pages/CentroCusto.context'
import { SubmitHandler } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { CentroCusto, UpdateCentroCustoSchema, centroCusto } from 'service/api'
import { toast } from 'sonner'
import { FormCentroCusto } from '../forms/FormCentroCusto'

export default function EditarCentroCusto() {
    const { id } = useParams()
    const { data } = useCentroCustoOutletContext()
    const centro = data?.find(item => item.id === Number(id))

    const { mutateAsync, isLoading } = centroCusto.mutations.useUpdate({
        invalidateQuery: true,
    })

    if (!centro) return null

    const handleSubmit: SubmitHandler<CentroCusto> = data =>
        mutateAsync(
            {
                ...data,
                predecessorId: data.predecessorId ? data.predecessorId : null,
            },
            {
                onSuccess: () => {
                    toast.success('Centro de custo atualizado com sucesso')
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )

    return (
        <Dialog.Root
            loading={isLoading}
            onSubmit={handleSubmit}
            defaultValues={{
                ...centro,
                predecessorId: centro.predecessorId || 0,
            }}
            schema={UpdateCentroCustoSchema}
            open={hasPermission(['update', 'CentrosDeCusto'])}
        >
            <Dialog.Title>Editar centro de custo</Dialog.Title>
            <Dialog.Content>
                <FormCentroCusto isEdicao />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
